import React, { useState, useEffect } from 'react';
import { Modal, Form, DatePicker, message } from 'antd';
import moment from 'moment';

import emiter, {
  EVENT_CARRENTAL_ADD_REST_DAY,
  EVENT_CARRENTAL_EDITTABLE_ADDROW,
  EVENT_CARRENTAL_UPDATE_DAY_OFF_LIST
} from '../../../../events';

import { addStoreRestDay } from 'hooks/carRental/store';

const { RangePicker } = DatePicker;

interface PropsType {
  enums?: any;
  permission?: any;
}

const SPRestDayAddModal: React.FC<PropsType> = (props) => {

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [storeInfo, setStoreInfo] = useState<any>({});

  const [mainForm] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    mainForm.validateFields().then(values => {
      const formData = mainForm.getFieldsValue();

      const { range_time: [startTime, endTime] } = formData || {};

      addStoreRestDay({
        store_code: storeInfo?.store_code,
        start_time: startTime.unix(),
        end_time: endTime.unix(),
      }).then(res => {
        message.success('操作成功');
        mainForm.resetFields();
        setIsModalOpen(false);
        emiter.emit(EVENT_CARRENTAL_UPDATE_DAY_OFF_LIST, storeInfo?.store_code);
      });
    }).catch(() => {

    });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleModelOpen = (data: any) => {
    setStoreInfo(data);
    showModal();
  }

  const mainFormFields = {
    rangeTime: { name: 'range_time', label: '休息时间', required: true, message: '请选择休息时间!', placeholder: '请选择时间', },
  };

  useEffect(() => {
    emiter.on(EVENT_CARRENTAL_ADD_REST_DAY, handleModelOpen);
    return () => {
      emiter.removeAllListeners(EVENT_CARRENTAL_ADD_REST_DAY)
    }
  }, []);


  return (
    <Modal title="新增休息日" width="600px" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
      <Form
        name="basic"
        form={mainForm}
        style={{ maxWidth: 600 }}
        autoComplete="off"
      >
        <Form.Item
          label={mainFormFields.rangeTime.label}
          name={mainFormFields.rangeTime.name}
          rules={[{ required: mainFormFields.rangeTime.required, message: mainFormFields.rangeTime.message }]}
        >
          <RangePicker
            showTime={{
              hideDisabledOptions: true,
              defaultValue: [moment('00:00:00', 'HH:mm'), moment('11:59:59', 'HH:mm')],
            }}
            format="YYYY-MM-DD HH:mm"
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default SPRestDayAddModal;
